<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <div class="imgBlock">
        <img alt="" src="../../assets/svg/removeIcon.png">
        <h1>Отказано</h1>
      </div>
    </div>

    <div>
      <button class="purpleButton" v-on:click="closePopUp">Понятно</button>
    </div>
  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';

export default {
  name: 'failed-popup',
  components: { CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    }
  }
};
</script>

<style scoped>
#popUpWin { height: calc(165.33vw - 10.67vw); display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>div>.imgBlock>h1 { margin-bottom: 2.13vw; text-align: center }
#popUpWin>div:last-child { display: flex; flex-direction: column }
#popUpWin>div:last-child>button { padding: 3.20vw 0 }
#popUpWin>div:last-child>button:first-child { margin-bottom: 2.13vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { height: calc(383px - 40px); width: calc(600px - 40px); }
  #popUpWin>div>.imgBlock>h1 { margin-bottom: 20px }
  #popUpWin>div:last-child { align-items: center; }
  #popUpWin>div:last-child>button { padding: 16px 0; width: 100% }
  #popUpWin>div:last-child>button:first-child { margin-bottom: 0 }
}

</style>
